import React, { useEffect, Fragment } from "react";

import { Form, Heading, Content } from "react-bulma-components";

import StructuredText from "common-frontend/util/structuredText";

const { Textarea, Field } = Form;

export function adjustQuestionResponses(responses, responseChanges) {
  if (!responseChanges) return responses;
  Object.entries(responseChanges).forEach(
    ([key, value]) => (responses[key] = value)
  );
  return responses;
}

function PromptQuestion({ question, currentAnswer, setAnswer }) {
  const { header, prompt_structured_text, mechanism } = question;

  const uninitialized = currentAnswer === undefined;

  useEffect(() => {
    if (uninitialized) setAnswer("");
  }, [uninitialized, setAnswer]);

  return (
    <Fragment>
      {header ? <Heading size={5}>{header}</Heading> : null}
      {prompt_structured_text ? (
        <div className="block">
          <StructuredText data={prompt_structured_text} />
        </div>
      ) : null}
      {mechanism === "textarea" ? (
        <Field>
          <Textarea
            value={currentAnswer ?? ""}
            onChange={(e) => setAnswer(e.target.value)}
          />
        </Field>
      ) : (
        <Content>
          <b>
            Internal error in registration form; please contact Fields Institute
            staff.
          </b>
        </Content>
      )}
    </Fragment>
  );
}

export function PromptQuestions({
  questions = [],
  currentAnswers,
  adjustAnswers,
}) {
  return questions.map((question) => {
    const currentAnswer = currentAnswers[question.description];
    const setAnswer = (newAnswer) =>
      adjustAnswers({ [question.description]: newAnswer });
    return (
      <PromptQuestion
        key={question}
        {...{ question, currentAnswer, setAnswer }}
      />
    );
  });
}
